<template>
  <div class="investment-advisory">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'InvestmentAdvisory',
};
</script>
